import { MaterialModule } from 'src/app/material/material.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationItemComponent } from './navigation-item.component';
import { IconModule } from '@visurel/iconify-angular';
import { RouterModule } from '@angular/router';
import { createTranslateLoader } from 'src/app/shared/utils/translate-utils';
import { HttpClient } from '@angular/common/http';

@NgModule({
  declarations: [NavigationItemComponent],
  imports: [
    CommonModule,
    IconModule,
    RouterModule,
    MaterialModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  exports: [NavigationItemComponent]
})
export class NavigationItemModule {}
